module.exports = __webpack_public_path__ + "img/csca-stacked-logo.9bb95b58.svg";